import * as PIXI from 'pixi.js-legacy';
import project from '../util/project';
import productService from '../../services/products';
import tacHelpers from '../../state/tac/tacHelpers';
import { ITEMS } from '../../constants';

const LEFT = 'left';
const RIGHT = 'right';

const bracketsMixin = superclass =>
  class extends superclass {
    // Override
    drawBracket(side) {
      if (!productService.getFittingBracket(this.item, side)) {
        // This is not a bracketed item.
        return;
      }

      const parent = tacHelpers.getParent(this.app.tac, this.item);
      const ancestor = tacHelpers.getTopAncestor(this.app.tac, this.item);

      if (!parent || !productService.isType(ancestor, ITEMS.SECTION_POSTS)) {
        return;
      }

      if (this._isDragging) {
        this.bracketContainers[side].alpha = 0;
        return;
      }
      this.bracketContainers[side].alpha = 1;

      if (this.brackets[side] && this.brackets[side].parent) {
        return;
      }

      let positionIdentifier;
      if (side === LEFT) {
        positionIdentifier = '_L';
      } else if (side === RIGHT) {
        positionIdentifier = '_R';
      } else {
        // We don't seem to have a valid direction.
        return;
      }

      const proppingTop = this._getProppingTop();

      const tacItem = tacHelpers.getItem(this.app.tac, this.item.itemid);
      const gItem = tacHelpers.getGlobalCoords(tacItem, this.app.tac);
      const bracket = tacItem.items.find(item =>
        item.modelid.includes(positionIdentifier)
      );
      if (!bracket) return;
      const gBracket = tacHelpers.getGlobalCoords(bracket, this.app.tac);
      const bracketOffset =
        gBracket.y + gBracket.height - (gItem.y + gItem.height);

      const resourceName = bracket.id;
      const resource = PIXI.Loader.shared.resources[resourceName];
      this.brackets[side] =
        this.brackets[side] || new PIXI.Sprite(resource.texture);
      const outerSize = project.outer(bracket);
      this.brackets[side].width = outerSize.width * this.ratio;
      this.brackets[side].height = outerSize.height * this.ratio;
      this.brackets[side].itemRef = bracket.itemid;
      if (side === RIGHT) {
        this.brackets[side].x = this.sprite.width - this.brackets[side].width;
      } else if (side === LEFT) {
        const bracketPairBox = {
          ...bracket,
          width: this.item.width,
        };
        const bracketPairBoxSize = project.outer(bracketPairBox);

        this.brackets[side].x =
          this.sprite.width - bracketPairBoxSize.width * this.ratio;
      }
      this.brackets[side].y = (proppingTop - bracketOffset) * this.ratio;

      if (!this.brackets[side].parent) {
        this.bracketContainers[side].addChild(this.brackets[side]);
      }
    }
  };

export default bracketsMixin;
